import { useContext, useMemo } from "react";

import TableContext from "context/table/tableContext";
import {
    FILTER_NAMES,
    ID_TYPE,
    TABLE_NAMES,
    TABLE_NAMES_WITH_FILTERS,
    TASK_GROUP_DETAILS_TASK_COLUMNS,
    usePermissions
} from "shared";

import TaskDetails from "../../Actions/dialogs/Tasks/TaskDetails";
import { useTaskInlineActions } from "../../Actions/InlineActions";
import Table from "../../Table";
import { TaskProps } from "./types";

const Tasks = ({ getTaskTableData }: TaskProps) => {
    const { detailsData, updateSingleRowData } = useContext(TableContext);

    const { inlineActions, taskData, isOpen, closeDialog, setTaskData } =
        useTaskInlineActions();

    const { isReadTaskNotAllowed } = usePermissions();

    const { id } = detailsData;

    const innerTableQueryParams = useMemo(
        () => ({
            [FILTER_NAMES.BatchId]: id
        }),
        [id]
    );

    return (
        <>
            <Table
                data-testid="tasks-table"
                name={TABLE_NAMES.Tasks}
                nameForFilters={TABLE_NAMES_WITH_FILTERS.TaskGroupDetailTasks}
                hasNoPermissionToRead={isReadTaskNotAllowed}
                isInnerTable
                initialColumns={TASK_GROUP_DETAILS_TASK_COLUMNS}
                inlineActions={inlineActions}
                idType={ID_TYPE.Id}
                sortFromNewest
                outerDetailsData={{
                    detailsData,
                    mainTableName: TABLE_NAMES.TaskGroups,
                    updateMainRowData: updateSingleRowData
                }}
                innerTableQueryParams={innerTableQueryParams}
                getInnerTableData={getTaskTableData}
            />

            <TaskDetails
                data={taskData}
                isOpen={isOpen}
                close={closeDialog}
                setTaskData={setTaskData}
            />
        </>
    );
};

export default Tasks;
